<template>
  <div>
    <!-- b-overlay :show="uploading" rounded="sm" -->
      <div>
        <h3 class="my-auto">
          <b-button @click.prevent="backtolist" variant="outline-primary">&lt; Return to list</b-button>
          <span v-if="material_id > 0" class="ml-4">{{material_heading}}</span>
           <span v-if="material_id < 0" class="ml-4">Add Material</span>
        </h3>
        <b-card no-body class="border-0 mx-0 px-0 py-10 pl-0 pr-0 col-12">
          <form autocomplete=off @submit.stop.prevent>
            <b-row>
              &nbsp;
            </b-row>
            <b-row>
              <b-form-group 
                label-cols="2"
                label="Heading"
                class="col-12"
                invalid-feedback="Material heading cannot be blank"
              >
                <b-form-input  
                  id="material_heading" 
                  :state="material_heading_valid"
                 class="form-control col-6"
                  v-model="material_heading"
                  v-on:change="savefield('g_elearning_materials',material_id,'material_heading',material_heading)" 
                  autocomplete="off"
                >
                </b-form-input>
              </b-form-group>

              <b-form-group 
               label-cols="2"
               label="Material file"
                class="col-12"
                  invalid-feedback="Material file cannot be blank"
              >
                {{material_filename}}
              </b-form-group>
              <b-form-group 
                label-cols="2"
                label="Upload new material file"
                class="col-12"
                invalid-feedback="Material file cannot be blank"
             >
               <b-form-file
                  class="col-6"
                  :state="material_file_valid"
                  v-model="material_file"
                  ref="material_file"
                  placeholder="Choose a file or drop it here."
                  drop-placeholder="Drop file here..."
                  @input="materialfile_save"
                ></b-form-file>
                <span class="col-4 float-right">
                </span>
              </b-form-group>         
              <div class="form-group col-12 mt-4">
                <b-button 
                  v-if="material_id < 1" 
                  @click.prevent="material_create" 
                  class="mt-10"
                  variant="primary"
                >
                  Save New Material
                </b-button>
              </div>
           </b-row>
          </form>
        </b-card>
      </div>
    <!-- /b-overlay -->
  </div>
</template>
<script>
export default {
  components: {
  },
  name: 'LearningMaterial',
  created() {
    this.material_get();
  },
  data: function() {
    return {
      material_heading: '',
      material_heading_valid: null,
      material_filename: '',
      material_file: null,
      material_file_valid: null,
      loading: true,
      uploading: false,
    }
  },
  computed: {
    material_id: {
      get() {
        return this.$store.state.currentelearningmaterial_id;
      }
    },
  },
  watch: {
    material_id: function() {
      this.material_get()
    }
  },
  methods: {
    checkform() {
      var formok = true;
      this.material_heading_valid = true;
      if (this.material_heading == '') { 
        this.material_heading_valid = false; 
        formok = false;
      }
      this.material_file_valid = true;
      if (this.material_file == null && this.material_id < 1) {
        this.material_file_valid = false;
        formok = false;
      }
      return formok;
    },
    materialfile_save() {
      if (this.$store.state.currentelearningmaterial_id > 0) {
        this.uploading = true;
        const fd = new FormData();
        fd.append('material_id',this.$store.state.currentelearningmaterial_id);
        fd.append('material_file',this.material_file);
        this.$store.dispatch('elearningmaterialfile_save', fd)
        .then(() => {
          this.uploading = false;
          this.material_get();
        });
      }
    },
    material_create() {
      if (this.checkform()) {
        const fd = new FormData();
        fd.append('material_heading',this.material_heading);
        fd.append('material_file',this.material_file);
        this.$store.dispatch('elearningmaterial_create', fd)
        .then((resp) => {
          var material_id = resp.data.id;
          this.$store.dispatch('elearningmaterial_setcurrent',{ material_id: material_id })
          .then(() => {
            this.material_get();
          });
        });
      }
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
          .then(() => {
            this.$store.dispatch('elearningmaterialchanged_set',{ material_id: this.material_id });
          });
        }
      }
    },
    material_get() {
      this.material_heading = '';
      this.material_file = null;
      this.material_filename = '';
      this.labels = [];
      if (this.material_id > 0) {
        this.$store.dispatch('elearningmaterial_fetch', { material_id: this.material_id })
        .then((resp) => {
          this.material_heading = resp.data.material_heading;
          this.material_filename = resp.data.material_filename;
          this.loading = false;
        });
      }
    },
    backtolist() {
      this.$store.dispatch('elearningmaterial_setcurrent',{ material_id: 0 })
    },
  }
}
</script>
<style>
</style>
